import { PRODUCT } from '@/utils/constants';

const PRODUCT_PREFIXES = Object.values(PRODUCT).map((product: string) => `${product}-`);

/**
 * GFE/CMS category uids are namespaced by product (`casino-jackpots`, `xsell-bonus-buys-...`).
 * A hub route slug can therefore already carry a product prefix — including a foreign one such as
 * `xsell-` served by the casino app — so we match against every known product, not just the
 * running one. Returns the matched leading `<product>-` token, or `undefined` when there is none.
 */
export const getLeadingProductPrefix = (uid: string): string | undefined =>
    PRODUCT_PREFIXES.find((prefix) => uid.startsWith(prefix));

/**
 * Resolves the product-prefixed uid GFE keys categories by. Keeps an existing product prefix
 * (avoids double-prefixing a foreign `xsell-`/`sportsbook-`/`poker-` slug into `casino-xsell-...`)
 * and otherwise prepends the running product to a bare slug.
 */
export const ensureProductPrefixedUid = (uid: string): string =>
    getLeadingProductPrefix(uid) ? uid : `${process.env.PRODUCT}-${uid}`;
